// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabpanel_root__KOcUO","hidden":"Tabpanel_hidden__f1YMq"};